import React from 'react'
import RootStore from '../../store'
import { CoBrandingHeader } from './Header'

export const ScreenWithCobrandingHeader: React.FC<{
  children: React.ReactElement
}> = ({ children }) => {
  return (
    <>
      {RootStore.branding && <CoBrandingHeader />}
      {children}
    </>
  )
}
